import React, { useState, useEffect, FC, ChangeEvent } from 'react';

interface ResetCountAlarmProps {
  alarm: {
    type: string;
    name: string;
    group: string;
    threshold: number | undefined;
  };
  onChange: (updatedAlarm: ResetCountAlarmProps['alarm']) => void;
}

const ResetCountAlarm: FC<ResetCountAlarmProps> = ({ alarm, onChange }) => {
  const [threshold, setthreshold] = useState<number>(alarm.threshold ?? 0);
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    setthreshold(alarm.threshold ?? 0);
  }, [alarm.threshold]);

  const handleThresholdChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    // Autoriser uniquement les entiers positifs
    const isPositiveInteger = /^\d+$/.test(value);

    if (isPositiveInteger) {
      const parsed = parseInt(value, 10);
      setthreshold(parsed);
      setErrorMessage('');
      onChange({ ...alarm, threshold: parsed });
    } else {
      setErrorMessage('Please enter a valid number.');
    }
  };

  return (
    <div className="form-group">
      <label htmlFor="resetThreshold" style={{ fontWeight: 'bold', display: 'block', marginBottom: '4px' }}>
        Nombre de réinitialisations
      </label>

      <div style={{ position: 'relative', display: 'inline-block', width: '200px' }}>
        <input
          type="number"
          id="resetThreshold"
          value={threshold}
          onChange={handleThresholdChange}
          className="form-control"
          min="0"
          step="1"
          style={{
            width: '100%',
            paddingRight: '60px',
            boxSizing: 'border-box'
          }}
        />
        <span
          style={{
            position: 'absolute',
            right: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#333',
            pointerEvents: 'none'
          }}
        >
          Resets
        </span>
      </div>

      {errorMessage && (
        <div
          className="error-message"
          style={{
            backgroundColor: '#ff7e41',
            color: 'white',
            marginTop: '5px',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '0.9em',
            display: 'inline-block'
          }}
        >
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default ResetCountAlarm;
